<template>
  <div>
    <div class="item-card">
      <content-line font-icon icon="screen_share" :text="title" />
      <video-container :participant="hostParticipant" />
    </div>
  </div>
</template>

<script>
import VideoContainer from './VideoContainer';
export default {
  name: 'ActionScreenShareContent',
  components: {
    VideoContainer,
  },
  props: {
    state: {},
    getSingleParticipant: {},
  },
  computed: {
    hostParticipant() {
      return this.getSingleParticipant(this.state?.hostId);
    },
    title() {
      return (
        (this.hostParticipant ? this.hostParticipant.name + "'s " : '') +
        'Screen'
      );
    },
  },
};
</script>
